/**
 * PostHog gate for the client-visible ("Dla klientki") report variant. The
 * generation and the RLS read arm for the client already exist, but there is no
 * delivery surface in the client apps yet (follow-up in TRE-2044) — until then the
 * option stays hidden so a trainer does not produce a report nobody can read.
 */
export const TRAINEE_AI_REPORT_CLIENT_AUDIENCE_FEATURE_FLAG = "trainee-ai-report-client-audience";
